import advantagesEn from "@locales/en/advantages.json";
import commonEn from "@locales/en/common.json";
import formErrorsEn from "@locales/en/form-errors.json";
import landingPageEn from "@locales/en/landing-page.json";
import metaTagsEn from "@locales/en/meta-tags.json";
import notFoundEn from "@locales/en/notFound.json";
import productFeaturesEn from "@locales/en/product-features.json";
import recaptchaEn from "@locales/en/recaptcha.json";
import skeyPoapEn from "@locales/en/skeyPoap.json";

import notFoundPl from "@locales/en/notFound.json";
import advantagesPl from "@locales/pl/advantages.json";
import commonPl from "@locales/pl/common.json";
import formErrorsPl from "@locales/pl/form-errors.json";
import landingPagePl from "@locales/pl/landing-page.json";
import metaTagsPl from "@locales/pl/meta-tags.json";
import productFeaturesPl from "@locales/pl/product-features.json";
import recaptchaPl from "@locales/pl/recaptcha.json";
import skeyPoapPl from "@locales/pl/skeyPoap.json";

export const resources = {
  en: {
    landingPage: landingPageEn,
    productFeatures: productFeaturesEn,
    advantages: advantagesEn,
    skeyPoap: skeyPoapEn,
    formErrors: formErrorsEn,
    recaptcha: recaptchaEn,
    metaTags: metaTagsEn,
    common: commonEn,
    notFound: notFoundEn
  },
  pl: {
    landingPage: landingPagePl,
    productFeatures: productFeaturesPl,
    advantages: advantagesPl,
    skeyPoap: skeyPoapPl,
    formErrors: formErrorsPl,
    recaptcha: recaptchaPl,
    metaTags: metaTagsPl,
    common: commonPl,
    notFound: notFoundPl
  }
} as const;
